import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const DocumentExpiryCategory = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography>{t('share_document_v3.automatic_reminders.automatic_document_expiry.choose_expiration_date')}</Typography>
        <DatePicker
          label={t('share_document_v3.automatic_reminders.automatic_document_expiry.expires_label')}
          defaultValue={dayjs()}
          sx={{
            '& .MuiInputBase-root': {
              padding: '0 12px',
            },
          }}
          slots={{
            openPickerIcon: KeyboardArrowDown,
          }}
        />
      </Stack>
      <Stack gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.automatic_document_expiry.when_expired_send')}</Typography>
        <Autocomplete
          size="small"
          options={[]}
          renderInput={(params) => (
            <TextField {...params} label={t('share_document_v3.automatic_reminders.automatic_document_expiry.document_expiry_label')} />
          )}
        />
      </Stack>
      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.automatic_document_expiry.send_notification_label')}</Typography>
        <TextField value={1} size="small" type="number" sx={{ width: 40 }} />
        <Typography>{t('share_document_v3.automatic_reminders.automatic_document_expiry.before_expiry')}</Typography>
      </Stack>
    </Stack>
  );
};
